module.exports = __webpack_public_path__ + "img/sankaku_75_red.ab293e21.png";